import { uniq } from 'lodash-es'

export function getViewingsFiltersKey(filterValues) {
  const params = new URLSearchParams()

  Object.entries(filterValues).forEach(([param, value]) =>
    [value].flat().forEach(entry => params.append(param, entry))
  )

  return params.toString()
}

export function getViewingsFilterValuesFromKey(filtersKey) {
  const params = new URLSearchParams(filtersKey)

  return Object.fromEntries(
    uniq([...params.keys()]).map(param => [param, params.get(param)])
  )
}
